import React from 'react';

import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';

import { TextWithTooltip } from '../../../../../../../helpers/TextWithTooltip';
import { Translate } from '../../../../../../../helpers/Translate';

import { SelectedMaterialsListItemLightboxTitleSelectedMaterial } from './SelectedMaterialsListItemLightboxTitle.types';

interface SelectedMaterialsListItemLightboxTitleProps {
  selectedMaterial: SelectedMaterialsListItemLightboxTitleSelectedMaterial;
}

function SelectedMaterialsListItemLightboxTitle({
  selectedMaterial
}: SelectedMaterialsListItemLightboxTitleProps) {
  return (
    <div className="flex-1 overflow-hidden p-1.5 text-left">
      <div className="text-sm">
        <div className="text-white truncate">
          {selectedMaterial.material?.blocked ? (
            <span className="bg-red-200 text-gray-800 px-1 py-0.5 text-xs rounded uppercase mr-1">
              <Translate id="forms.fields.blocked" />
            </span>
          ) : null}
          <TextWithTooltip
            text={selectedMaterial.material?.name}
            className="font-medium"
            tooltipPlacement={TooltipPlacement.BOTTOM}
          />
        </div>
        <div className="text-gray-300 truncate">
          {selectedMaterial.material?.nda ? (
            <span className="bg-yellow-200 text-gray-800 px-1 py-0.5 text-xs rounded uppercase mr-1">
              <Translate id="forms.fields.nda" />
            </span>
          ) : null}
          {selectedMaterial.material?.brand ? (
            <TextWithTooltip
              text={selectedMaterial.material?.brand?.name}
              tooltipPlacement={TooltipPlacement.BOTTOM}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SelectedMaterialsListItemLightboxTitle;
